
const UserProfileButtonComponent = {
    templateUrl: '/userProfileButton/userProfileButton.tpl.html',
    controller: 'userProfileButtonController',
    bindings: {
        showChatIcon: '<',
        menuItems: '<'
    }
};

angular.module('gw-um-header')
    .component('uiUserProfileButton', UserProfileButtonComponent);
